// @ts-nocheck
import useAccount from "classes/Accounts/hooks/useAccount";
import WorkFunctionObject from "classes/Professions/WorkFunctionObject";
import { ConditionalSelect } from "components/Inputs/CustomAsyncSelect/CustomCreatableSelect";
import genRequest from "includes/request";
import { t } from "i18next";
import React from "react";

export default function WorkFunctionSelect(props) {
	const {isAdmin} = useAccount();

	function handleAddWFU(new_item) {
		let obj = new WorkFunctionObject({
			workFunctionName: new_item.label,
			companyId: props.companyId
		});
		let req = obj.send().then((resp) => {
			return ({
				label: resp.workFunctionName,
				value: resp.workFunctionId,
				workFunctionId: resp.workFunctionId,
			});
		});
		return (req);
	}

	return (
		<ConditionalSelect
			placeholder={t("WorkFunctions.SELECT_FUNC")}
			className={"bg-color w-100 rounded"}
			classNamePrefix="dropdown"
			queryKey={["WorkFunctions", "WorkFunctionOfCompany", props.companyId]}
			queryFn={() => genRequest("work-functions/company/" + props.companyId)}
			treat={(wfu) => ({
				value: wfu.id,
				workFunctionId: wfu.id,
				label: wfu.name
			})}
			isSearchable={true}
			onCreateOption={isAdmin() ? handleAddWFU : false}
			{...props}
		/>
	);
}
